/**
 * Analytics helper for GA4 events
 *
 * Supports gtag (direct) and GTM (dataLayer)
 * No-op if neither is available (SSR-safe)
 */

export function track(eventName, params = {}) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params)
    } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: eventName, ...params })
    } else {
      return
    }

    if (window.localStorage?.getItem('DEBUG_ANALYTICS') === '1') {
      console.log('[analytics]', eventName, params)
    }
  } catch {
    return
  }
}

/**
 * Track page view
 */
export function trackPageView(pageName, params = {}) {
  track('page_view', {
    page_title: pageName,
    ...params,
  })
}

/**
 * Track city page view
 */
export function trackViewCity(citySlug) {
  track('view_city', {
    city_slug: citySlug,
  })
}

/**
 * Track park detail page view
 */
export function trackViewPark(citySlug, parkSlug) {
  track('view_park', {
    city_slug: citySlug,
    park_slug: parkSlug,
  })
}

/**
 * Track "Cómo llegar" button click
 */
export function trackClickDirections(citySlug, parkSlug) {
  track('click_directions', {
    city_slug: citySlug,
    park_slug: parkSlug,
  })
}

/**
 * Track "Sugerir parque" button click
 */
export function trackSuggestParkClick(citySlug) {
  track('suggest_park_click', {
    city_slug: citySlug,
  })
}

/**
 * Track search/filter in city page
 */
export function trackSearchCity(citySlug, queryLength) {
  track('search_city', {
    city_slug: citySlug,
    query_length: queryLength,
  })
}

/**
 * Track filter apply in city page
 */
export function trackFilterApply(citySlug, filtersCount) {
  track('filter_apply', {
    city_slug: citySlug,
    filters_count: filtersCount,
  })
}
